import * as React from 'react'
import AlgoliaSearch from '../algolia-search'
import Hits from './hits'
import SearchInput from './search-input'

interface IProps {
  indexName: string
  widgetName: string
  showSearch?: boolean
  theme?: string
}

export default class extends React.Component<IProps> {
  public render() {
    const { showSearch = true } = this.props
    return (
      <AlgoliaSearch
        indexName={this.props.indexName}
        widgetName={this.props.widgetName}
      >
        {showSearch && <SearchInput />}
        <Hits theme={this.props.theme} />
      </AlgoliaSearch >
    )
  }
}
